<template>
        <a
          class="link-green"
          href="https://www.linkedin.com/in/saul-verde-martinez/"
          target="_blank"
          role="button"
          >Linkedin</a>
</template>

<script>
export default {
  name: "LinkedinButton",
  setup() {}
};
</script>
